export const BULK_DOWNLOAD_MAX = 50;
